import { useCallback } from 'react';
import { useOverlappingFeaturesState } from 'state/useOverlappingFeaturesState';
import { usePoisState } from 'state/usePoisState';
import { SingletonPoi } from 'features/mapping/mapping.types';

/**
 * Selects a singleton POI as a replace-all: clears any active stacked-nav footer so
 * nothing stale lingers behind the singleton dialog.
 *
 * Does not call clearSelectedPois - setSelectedSingletonPoi already replaces the selection.
 * Keeping the side-effect clearing here lets the aircraft metadata-refresh effect call the
 * raw setter without wiping the stacked nav on every altitude/speed update.
 */
export const useSelectSingletonPoi = (): ((poi: SingletonPoi) => void) => {
  const { setSelectedSingletonPoi } = usePoisState();
  const { clearOverlappingFeatures } = useOverlappingFeaturesState();

  return useCallback(
    (poi: SingletonPoi) => {
      clearOverlappingFeatures();
      setSelectedSingletonPoi(poi);
    },
    [clearOverlappingFeatures, setSelectedSingletonPoi],
  );
};
